import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';

import genericSelectSlice from 'modules/global/reducers/generic.selectSlice';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import * as types from 'modules/vehicleCheckModels/actionTypes';

import defaultEntity from './defaultEntity';
import details from './details';

/**
 * @typedef {{
 *   loading: {
 *     deleting: boolean,
 *     cloning: boolean,
 *     creating: boolean,
 *     updating: boolean,
 *   },
 *   dashboard: {
 *     dealer: import('modules/global/reducers/simpleSearchReducer').SimpleSearchReducer,
 *     group: import('modules/global/reducers/simpleSearchReducer').SimpleSearchReducer,
 *   },
 *   details: import('./details').VehicleCheckModelsUIDetailsReducer,
 *   selects: import('modules/global/reducers/generic.selectSlice').GenericSelectsReducer,
 *   defaultEntity: import('./defaultEntity').VehicleCheckModelsUIDefaultEntityReducer,
 * }} VehicleCheckModelsUIReducer
 * */

const removeEntity = (state, { payload: vehicleCheckModelId }) => state.filter(id => id !== vehicleCheckModelId);

const destroySelect = (state, { payload: selectId }) => {
  const { [selectId]: _, ...newState } = state;
  return newState;
};

export default combineReducers({
  selects: genericSelectSlice(types.FETCH_VEHICLE_CHECK_MODELS, {
    reducers: { [types.DESTROY_SELECT]: destroySelect },
  }),
  loading: combineReducers({
    cloning: loading(types.CLONE_VEHICLE_CHECK_MODEL),
    deleting: loading(types.DELETE_VEHICLE_CHECK_MODEL),
    creating: loading(types.CREATE_VEHICLE_CHECK_MODEL),
    updating: loading(types.UPDATE_VEHICLE_CHECK_MODEL),
  }),
  dashboard: combineReducers({
    dealer: createSearchReducers(types.FETCH_VEHICLE_CHECK_MODELS, {
      ids: {
        [types.DELETE_VEHICLE_CHECK_MODEL_SUCCESS]: removeEntity,
      },
      global: {
        paginationSlice: true,
        matcher: ({ meta }) => meta?.source === 'dealer-dashboard',
      },
    }),
    group: createSearchReducers(types.FETCH_VEHICLE_CHECK_MODELS, {
      ids: {
        [types.DELETE_VEHICLE_CHECK_MODEL_SUCCESS]: removeEntity,
      },
      global: {
        paginationSlice: true,
        matcher: ({ meta }) => meta?.source === 'group-dashboard',
      },
    }),
  }),
  details,
  defaultEntity,
});
